<template>
  <fragment>
    <p class="mb-0 darkBluishGray--text caption font-weight-medium">
      {{ title }}
    </p>
    <p class="body-2 font-weight-bold primary--text">
      {{ item }}
    </p>
    <v-divider />
  </fragment>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    item: {
      type: String
    }
  }
};
</script>
